import React from 'react';
import LargeTooltip from '../../components/LargeTooltip';
import { gql } from '../../graphql/generated/gql';
import type { DocumentType } from '../../graphql/generated/gql';
import { PostType } from '../../graphql/generated/graphql';
import newTabIcon from '../../icons/non-prefilled/16x16/newTab.svg';

const POST_FRAGMENT = gql(`
  fragment PostStateBarTooltip_post on Post {
    id
    type
  }
`);

interface PostStateBarTooltipProps {
  post: DocumentType<typeof POST_FRAGMENT>;
  anchorElement: HTMLElement | null;
  children: React.ReactNode;
}

const PostStateBarTooltip = ({
  post,
  children,
  anchorElement,
}: PostStateBarTooltipProps) => {
  return (
    <LargeTooltip
      content={
        post.type === PostType.Template
          ? {
              heading: 'Templatized post',
              paragraph: 'Create new posts from this template’s contents',
              button: {
                newTab: true,
                to: 'https://help.slab.com/en/articles/4281672-post-templates',
                icon: newTabIcon,
                text: 'Learn more',
              },
            }
          : null
      }
      anchorElement={anchorElement}
      placement="bottom"
    >
      <div>{children}</div>
    </LargeTooltip>
  );
};

export default PostStateBarTooltip;
